import { createAction, props } from '@ngrx/store';

export const SetTheme = createAction('[Nav] Set Theme', props<{ theme: string }>());
